module.exports = __webpack_public_path__ + "img/Noctiluca-Process-3.7a06f413.png";